// @flow

import _ from 'lodash';
import { connect } from 'react-redux';

import { logout } from 'client/actions/loginLogout';
import HomeNav from 'client/components/homeNav/homeNav';

const mapStateToProps: Object = (state) => {
  const {
    user: { isLoggedIn },
  } = state;
  const commonTranslations = _.get(state, 'translations.common', {});

  return {
    commonTranslations,
    isLoggedIn,
  };
};

export default connect(mapStateToProps, {
  logout,
})(HomeNav);
